












import { defineComponent } from '@vue/composition-api';

import CsvExport from './CsvExport.vue';
import { editOpen } from '../state';

export default defineComponent({
  name: 'Edit',
  components: { CsvExport },
  setup() {
    return { editOpen };
  },
});
